import { render, staticRenderFns } from "./add-google-certificate.vue?vue&type=template&id=b88267ac&"
import script from "./add-google-certificate.ts?vue&type=script&lang=ts&"
export * from "./add-google-certificate.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports